import * as React from 'react'

export interface IBlockTransitionContext {
  enable?: () => any
  disable?: () => any
}

export const BlockTransitionContext = React.createContext<IBlockTransitionContext>({
})
